import React, { useState } from "react";
import {
  useGetImageDesignMutation,
  useDeleteImageDesignMutation,
  useUploadImageDesignMutation,
} from "../services/PortfolioSerivce/PortfolioService";
import { Button, Modal } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { CheckCircleFilled } from "@ant-design/icons";
import middlewareAuthenticator from "../utils/middlewareAuthenticator";
import LocalStorageService from "../utils/LocalStorageService";

const EditImageDesign = () => {
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [file_image, setFileImage] = useState("");
  const [getImageDesign, result_image_design] = useGetImageDesignMutation();
  const [uploadImage, result_upload_image] = useUploadImageDesignMutation();
  const [deleteImageDesign, result_delete_image] =
    useDeleteImageDesignMutation();
  const [modal, contextHolder] = Modal.useModal();

  const fnImageDesign = async () => {
    try {
      const result = await getImageDesign().unwrap();
    } catch (err) {
      console.log(err);
    }
  };

  const fnDeleteImageDesign = async (id_image: string) => {
    try {
      const result = await deleteImageDesign({ id_image }).unwrap();
      if (result.status === 200) {
        fnImageDesign();
      }
      // console.log(result);
    } catch (err) {
      console.log(err);
    }
  };

  const logOut = () => {
    navigate("/back-login");
    LocalStorageService.clearAccessToken();
  };

  const config_modal_logout = {
    title: "Logout?",
    content: null,
    closable: true,
  };

  const config = {
    title: "Delete?",
    content: null,
    closable: true,
  };

  const data_route = [
    {
      path: "/",
      title: "Home",
    },
    {
      path: "/back-admin",
      title: "Admin",
    },
    {
      path: "/back-admin/edit-data",
      title: "Edit data",
    },
    {
      path: "/back-admin/edit-image-design",
      title: "Edit Image Design",
    },
  ];

  const handleUpload2 = async () => {
    try {
      if (selectedFile) {
        const result = await uploadImage(selectedFile).unwrap();
        if (result.status === 200) {
          console.log("Upload Success", result.data);
        }
      }
    } catch (err) {
      console.error("Error uploading file:", err);
    }
  };

  const handleFileChange2 = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const file: File = event.target.files[0];
      setSelectedFile(file);
      setFileImage(URL.createObjectURL(file));
    }
  };

  return (
    <div className="flex flex-col items-center ">
      <div className="flex flex-row items-start mx-[20px] mt-[30px] max-w-[700px] w-full justify-between xs:flex-col gap-[10px]">
        <div className="flex flex-row gap-[10px]">
          {data_route.map((item) => (
            <>
              <Link
                key={item.title}
                to={item.path}
                className="bg-custom-primary-100 text-[14px] px-[10px] rounded-[5px] hover:bg-white text-white hover:text-custom-gray-100 duration-200"
              >
                {item.title}
              </Link>
            </>
          ))}
        </div>

        <button
          onClick={async () => {
            const confirmed = await modal.confirm(config_modal_logout);
            if (confirmed) {
              logOut();
            }
          }}
          className="bg-white text-[14px] px-[10px] rounded-[5px] text-custom-primary-100 hover:text-white duration-200 hover:bg-custom-primary-100 "
        >
          Logout
        </button>
      </div>

      <div className="flex flex-col items-start bg-custom-primary-25 w-full max-w-[700px] p-[20px] rounded-[15px] mt-[10px]">
        <h1 className="text-[20px] text-custom-gray-100">Image Design</h1>

        <div className="flex flex-col gap-[10px]">
          <input type="file" onChange={handleFileChange2} />
          {/* Upload Image */}
          {file_image.length !== 0 ? (
            <>
              <img
                src={file_image}
                className="w-[200px] h-full rounded-[10px]"
              />
              <Button
                onClick={handleUpload2}
                className="bg-white px-[10px] rounded-[5px] w-[200px] hover:bg-slate-200"
                loading={result_upload_image.isLoading}
              >
                {result_upload_image.isSuccess ? (
                  <CheckCircleFilled className="text-green-400" />
                ) : (
                  ""
                )}{" "}
                Upload
              </Button>
            </>
          ) : (
            <></>
          )}
        </div>

        <Button className="bg-white mt-[10px]" onClick={() => fnImageDesign()}>
          List Image Design
        </Button>

        <div className="grid grid-cols-4 gap-[20px] mt-[20px]">
          {contextHolder}
          {result_image_design.data?.data?.map((item) => (
            <>
              <div key={item._id} className="flex flex-col gap-[5px] relative">
                <img
                  src={item.url_image}
                  className="object-cover rounded-[20px] "
                />
                <button
                  onClick={async () => {
                    const confirmed = await modal.confirm(config);
                    if (confirmed) {
                      console.log("Confirmed: ", item._id);
                      fnDeleteImageDesign(item._id);
                    } else {
                      console.log("Cancel");
                    }
                  }}
                  className="bg-white flex justify-center items-center rotate-45 h-[20px] text-[16px] w-[20px] rounded-[50px] hover:bg-slate-200 absolute right-[-8px] top-[-8px]"
                >
                  +
                </button>
              </div>
            </>
          ))}
        </div>
      </div>
    </div>
  );
};

export default middlewareAuthenticator(EditImageDesign, {
  pageAction: "USE_AUTH",
});
